/**
 * ShopPad Infinite Options – EN-Lokalisierung der sichtbaren PDP-Labels. v2
 *
 * Grund: ShopPad hat KEINE eigene i18n und KEINE Translate-&-Adapt-Integration.
 * Wir uebersetzen die client-side gerenderten Labels theme-seitig per Woerterbuch.
 *
 * Die Uebersetzungs-Maps liegen zentral in option-i18n-data.js (window.SPOptionI18n),
 * damit PDP (hier) und Warenkorb/Checkout (product-form.js) DIESELBE Quelle nutzen.
 * Erweitern -> dort in LABELS / COLORS ergaenzen.
 *
 * Laeuft NUR auf der EN-Storefront (<html lang="en...">), DE bleibt unberuehrt.
 * ShopPad rendert async -> MutationObserver. Idempotent via data-sp-i18n.
 */
(function () {
  'use strict';
  if ((document.documentElement.lang || '').toLowerCase().indexOf('en') !== 0) return;
  if (!window.SPOptionI18n) return;

  const EXACT = window.SPOptionI18n.LABELS;
  const translateColor = window.SPOptionI18n.translateValue;

  function run() {
    // 1. Swatch-Labels (sichere ShopPad-Klasse)
    document.querySelectorAll('.spb-swatchlabel').forEach((el) => {
      if (el.dataset.spI18n) return;
      const t = translateColor(el.textContent);
      if (t && t !== el.textContent) { el.textContent = t; }
      el.dataset.spI18n = '1';
    });
    // 2. Option-Gruppen-Ueberschriften + client-seitige Hinweise (z.B. ShopPads "inkl. MwSt.")
    //    exakt matchen. Geschuetzte Leerzeichen (NBSP) werden normalisiert, sonst schluepft
    //    z.B. "inkl. MwSt." durch den Vergleich mit dem Woerterbuch-Key "inkl. MwSt.".
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const v = node.nodeValue.replace(/\u00a0/g, ' ').trim();
        return EXACT[v] ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    const hits = [];
    while (walker.nextNode()) hits.push(walker.currentNode);
    hits.forEach((node) => {
      const norm = node.nodeValue.replace(/\u00a0/g, ' ');
      const v = norm.trim();
      if (EXACT[v]) { node.nodeValue = norm.replace(v, EXACT[v]); }
    });
  }

  function init() {
    run();
    // childList + characterData: ShopPad/Apps rendern Preis & Hinweise async und aktualisieren
    // teils bestehende Text-Knoten (characterData, nicht childList). disconnect waehrend run()
    // verhindert, dass die eigene Uebersetzung den Observer erneut ausloest (keine Endlosschleife).
    const obs = new MutationObserver(() => {
      obs.disconnect();
      run();
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
